module.exports = __webpack_public_path__ + "img/GetConnectedBG.f70994e9.jpg";